import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DataSetComponent } from 'src/app/components/data-set/data-set.component';
import { ApiService } from 'src/app/services/api.services';
import {
	BannerMessageService,
	BannerMessageType,
} from 'src/app/services/banner-message.service';
import { Contact, AddEditContactDetailRequest } from '../../../models/contacts';
import { MatButton } from '@angular/material/button';
import { LoadingIndicatorComponent } from '../../../components/loading-indicator/loading-indicator.component';
import { MatDivider } from '@angular/material/list';
import { ListOfContactComponent } from '../list-of-contact/list-of-contact.component';
import { AddEditContactComponent } from '../add-edit-contact/add-edit-contact.component';

@Component({
	selector: 'app-contacts-of-notification-main',
	templateUrl: './contacts-of-notification-main.component.html',
	styleUrls: [
		'./contacts-of-notification-main.component.scss',
		'../../common/main.scss',
	],
	imports: [
		MatButton,
		LoadingIndicatorComponent,
		MatDivider,
		ListOfContactComponent,
		AddEditContactComponent,
	],
})
export class ContactsOfNotificationMainComponent implements AfterViewInit {
	@ViewChild(DataSetComponent) dataSet!: DataSetComponent;

	@Input() clientId!: string;
	@Input() canEdit = false;

	displayedColumns: any = [];
	dataSource = new MatTableDataSource<Contact>([]);
	isEditing: boolean = false;
	btnSaveClick: boolean = false;
	message: string = '';
	isSaveBtnDisable: boolean = false;

	constructor(
		private readonly apiService: ApiService,
		private readonly bannerMessageService: BannerMessageService
	) {
		this.smsNotificationFlagCheck();
	}

	ngAfterViewInit() {
		this.fetchListOfContacts();
	}

	//* Added the list of contact fetch logic here :
	async fetchListOfContacts(): Promise<void> {
		let contactList: Contact[] = await this.apiService.getContactList(
			this.clientId,
			[]
		);
		this.dataSource.data = contactList?.length > 0 ? contactList : [];
	}

	editBtnClick(): void {
		this.isEditing = !this.isEditing;
	}

	saveBtnClick(): void {
		this.btnSaveClick = true;
	}

	cancelClick(): void {
		this.isEditing = false;
		this.fetchListOfContacts();
	}

	// Send to API the form data received from child component :
	async onFormDataSubmitted(formData: any[]): Promise<void> {
		if (formData?.length === 0) {
			this.btnSaveClick = false;
			return;
		}

		const requestBody: AddEditContactDetailRequest = {
			clientId: formData[0]?.clientId ? formData[0].clientId : this.clientId,
			contactDetails: formData.map((item) => ({
				id: item.id ?? '',
				firstName: item.firstName,
				lastName: item.lastName,
				email: item.email ?? '',
				phoneNumber: item.phoneNumber?.rawPhoneNumber ?? '',
				countryCode: item.phoneNumber?.countryCode ?? '',
				active: item.isActive,
			})),
		};

		this.message = '';
		let messageType: BannerMessageType;
		try {
			const postContactDetails =
				await this.apiService.postContactDetails(requestBody);
			if (postContactDetails?.data?.message) {
				this.message = $localize`:@@contactDetail-save-message:Contact(s) added or updated successfully`;
				messageType = BannerMessageType.success;
				this.isEditing = false;
				this.btnSaveClick = false;

				this.fetchListOfContacts();
			} else {
				messageType = BannerMessageType.error;
				this.isEditing = false;
				this.btnSaveClick = false;
			}
		} catch (err) {
			this.message = $localize`:@@userAbout-saveErrorMessage:Error saving changes`;
			console.error('Error saving changes: ', err);
			messageType = BannerMessageType.error;
			this.isEditing = false;
			this.btnSaveClick = false;
		}

		this.bannerMessageService.sendMessage(this.message, messageType);
	}

	smsNotificationFlagCheck(): void {
		// Checks that the active company has the sms Notifications feature enabled :
		this.apiService
			.getCompanySettingByName('smsNotifications')
			.then((companySetting) => {
				this.displayedColumns = companySetting?.value
					?.toLowerCase()
					?.startsWith('true')
					? ['firstName', 'lastName', 'email', 'mobileNumber', 'onOff']
					: ['firstName', 'lastName', 'email', 'onOff'];
			});
	}

	updatedListAfterNewRow(formArrayList: any): void {
		setTimeout(() => {
			this.isSaveBtnDisable = formArrayList === false ? true : false;
		}, 0);
	}
}
